<template>
  <div class="container col-md-4 col-md-offset-3">
    <logo style="text-align: center;" />
    <p style="margin-top: 10px; text-align: center;">
      This the login for the <strong>Allied</strong>Crowds Dashboard
    </p>
    <form v-on:submit.prevent v-if="!authenticated">
      <hr />
      <div style="margin-top: 40px; margin-bottom: 30px" class="form-group">
        <div class="form-group input-group">
          <span style="background: white;" class="input-group-addon"
            ><i class="fa fa-envelope icon"></i
          ></span>
          <input
            name="username"
            class="form-control"
            v-model="username"
            type="email"
            placeholder="Email"
          />
        </div>
        <div class="form-group input-group">
          <span style="background: white;" class="input-group-addon"
            ><i class="fa fa-key icon"></i
          ></span>
          <input
            name="password"
            class="form-control"
            v-model="password"
            type="password"
            placeholder="Password"
          />
        </div>
        <input
          type="submit"
          class="btn-default login-button"
          v-on:click="submitLogin"
        />
      </div>
    </form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import logo from "../elements/logo.vue";

export default {
  name: "login-page",
  components: {
    logo: logo
  },
  data: function() {
    return {
      username: "",
      password: ""
    };
  },
  computed: {
    ...mapGetters({
      authenticated: "authenticated"
    })
  },
  methods: {
    submitLogin: function() {
      this.$store
        .dispatch("login", {
          username: this.username,
          password: this.password
        })
        .then(token => {
          this.$store.dispatch("addMessage", {
            text: "Login successful.",
            type: "info",
            duration: 5000
          });
          this.$store.commit("setOneTimeAccess", false);
          this.$router.push({ name: "search" });
        })
        .catch(err => {
          this.$store.dispatch("addMessage", {
            title: "Failed Login",
            text: "Login unsuccessful, please try again.",
            type: "error",
            duration: 5000
          });
          this.password = "";
        });
    },
    submitLogout: function() {
      this.$store.dispatch("logout").then(() => {
        this.password = "";
      });

      this.$store.token.commit("setToken", { access_token: "" });
    }
  }
};
</script>
<style scoped>
.login-button {
  margin: auto;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/loginPage.vue